import {Injectable} from "@angular/core";
import {IFeatureFlag} from "../models/featureFlag";
import {FeatureFlagDataService} from "./featureFlag-data.service";

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService {

    private _featureFlags: IFeatureFlag[] = [];
    private _initialized = false;

    constructor(private featureFlagDataService: FeatureFlagDataService) { }

    featureOff(featureCode: string) {
        return !this.featureOn(featureCode);
    }

    featureOn(featureCode: string) {
        if (!featureCode) {
            return true;
        }

        // Find the feature flag that is turned on
        return this._featureFlags && this._featureFlags.find(feature => {
            return feature.featureCode.toLowerCase() == featureCode.toLowerCase();
        }) != null;
        // if feature not found, default to turned off
    }

    get initialized() {
        return this._initialized;
    }

    // Hold list of features in memory
    public async initialize() {
        this._featureFlags = [];
        return new Promise<void>(async (resolve, reject) => {
            this.featureFlagDataService.getFeatureFlags().subscribe((featureFlags) => {
                this._featureFlags = featureFlags;
            });
            resolve();
        });
    }
}